import { paths } from "api/schema/api-schema";
import { djangoClientQueryFactory } from "api/client/helpers/queryFactory";
import { ToolSpec } from "types/json-schemas/type_guards";

type WorkflowToolSpecParam = ToolSpec["params"][number];

const path = "/wrs/workflow/validate_tables/" satisfies keyof paths;

type WorkflowGraph =
  paths[typeof path]["post"]["responses"][200]["content"]["application/json"];

// The backend doesn't have typing yet for tool spec parameters, so keep same narrowing (?) as before
type WithToolSpecParam<T> = Omit<T, "param"> & { param: WorkflowToolSpecParam };

export type ValidateTablesResponse = Omit<
  WorkflowGraph,
  "inputs" | "parameters"
> & {
  inputs: WithToolSpecParam<WorkflowGraph["inputs"][number]>[];
  parameters: WithToolSpecParam<WorkflowGraph["parameters"][number]>[];
};

export type ValidateTablesResult =
  | { error: string; data: undefined }
  | { error: undefined; data: ValidateTablesResponse };

export const workflowValidateTables = djangoClientQueryFactory(
  { path, method: "post" },
  {
    formatInput: (
      body: paths[typeof path]["post"]["requestBody"]["content"]["application/json"],
    ) => ({ body }),
    handleResponse: (res): ValidateTablesResult => {
      if (res.data !== undefined) {
        return { error: undefined, data: res.data as ValidateTablesResponse };
      }

      const cycleError =
        res.error?.type === "validation_error"
          ? res.error.errors.find((e) => e.code === "workflow_cycle_error")
          : undefined;

      return {
        error: cycleError?.detail ?? "Failed to generate workflow.",
        data: undefined,
      };
    },
  },
);
